<!-- 分配角色 组件 -->
<script setup>
import {defineProps, defineEmits} from 'vue';

const props = defineProps({
  user: {
    type: Object,
    default: {}
  },
});

</script>

<template>
  <div>分配角色：{{ user }}</div>
</template>

<style scoped>

</style>